import GantComponent from './GantComponent'
import enhance from './GantComponent.enhancer'

export default enhance(GantComponent)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/GantListaFiltrada/components/GantComponent/index.js